export const root = "/"
export const education = "/education"
export const employment = "/employment-history"
export const myTravels = "/my-travels"
export const glossary = "/glossary"
export const dashboard = "/dashboard"
export const afrianska = "/afrianska"
export const fashion = "/fashion-blog"
export const cake = "/cake"
export const contacts = "/contacts"